import styled from 'styled-components';
export const PageContainer = styled.div `
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.beige_2};
  min-height: 100%;
  opacity: ${({ $loading }) => ($loading ? 0 : 1)};
  transition: opacity 2s ease-in-out;
  position: relative;
`;
